var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c-0.006-5.52-4.48-9.994-9.999-10h-0.001zM18.482 17.575c-1.577 1.819-3.89 2.962-6.471 2.962-4.721 0-8.549-3.828-8.549-8.549s3.828-8.549 8.549-8.549c4.721 0 8.549 3.828 8.549 8.549 0 0.004 0 0.008 0 0.012v-0.001c-0.002 2.137-0.788 4.089-2.087 5.586l0.009-0.011z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.361 9.811l-5.514 5.426c-0.135 0.134-0.322 0.216-0.527 0.216s-0.392-0.083-0.527-0.216l-2.134-2.106c-0.143-0.137-0.232-0.329-0.232-0.542 0-0.414 0.336-0.75 0.75-0.75 0.209 0 0.399 0.086 0.535 0.224l0 0 1.609 1.587 4.987-4.907c0.133-0.123 0.312-0.198 0.508-0.198 0.414 0 0.75 0.336 0.75 0.75 0 0.2-0.078 0.382-0.206 0.516l0-0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-circle.dc4d8b67.svg";
export { ForwardRef as ReactComponent };